<template>
  <div class="position-relative" v-click-outside="hideDropdown">
    <input-qr-scan-model
      v-model="code"
      ref="codeRef"
      label="Voucher"
      :readonly="true"
      @keyupEnter="scanInput"
      @onFocus="showDropdown"
    ></input-qr-scan-model>
    <div class="position-absolute result-list" v-if="dropdown">
      <template v-if="suggestions.length > 0">
        <div
          class="result-item"
          :class="{
            'selected-item': idVoucher === suggestion.id,
          }"
          v-for="(suggestion, sindex) in suggestions"
          :key="`s_${sindex}_${suggestion.phone}`"
          @click="selectItem(suggestion)"
        >
          <b>{{ suggestion.code }}</b> -
          <span>{{ suggestion.name }}</span>
        </div>
      </template>
      <template v-else>
        <div class="result-item font-italic">
          <div>
            {{ "Quét QR voucher nếu có" }}
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "Voucher",
  components: {},
  props: {
    vouchers: {
      type: Array,
      default: () => [],
    },
    idCountry: {
      type: Number,
      default: () => 0,
    },
    idVoucher: {
      type: Number,
      default: () => 0,
    },
  },
  model: {
    prop: ["value"],
    event: "change",
  },
  data: () => ({
    dropdown: false,
    suggestions: [],
    code: null,
  }),
  watch: {
    idCountry() {
      this.voucherDefault();
    },
  },
  mounted() {
    this.voucherDefault();
  },
  methods: {
    voucherDefault() {
      this.suggestions = [...this.vouchers].filter(
        (v) => (this.idCountry && v.id_country == this.idCountry) || v.id == this.idVoucher
      );
      if (this.idVoucher) {
        const voucher = [...this.vouchers].find((v) => v.id == this.idVoucher);
        if (voucher) {
          this.code = voucher.code;
        }
      }
    },
    scanInput() {
      const voucher = this.vouchers.find((v) => v.code == this.code);
      if (!voucher) {
        document.getElementById("error_sound_player").play();
        this.$vToastify.error(this.$t("Voucher không đúng hoặc đã hết hạn"));
        this.code = null;
        return false;
      }
      this.suggestions.push(voucher);
      this.selectItem(voucher);
      document.getElementById("success_sound_player").play();
    },
    selectItem(item) {
      this.code = item.code;
      this.updateValue(item.id);
      this.hideDropdown();
    },
    updateValue(val) {
      this.$emit("change", val);
    },
    showDropdown() {
      this.dropdown = true;
    },
    hideDropdown() {
      this.dropdown = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.result-list {
  width: 100%;
  background: #fff;
  z-index: 1;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.3);
  max-height: 280px;
  overflow-y: auto;
  border-radius: 0 0 5px 5px;

  .result-item {
    padding: 8px;
    border-bottom: 1px solid #f3f3f3;
    font-size: 12px;

    &:hover {
      background: #efefef;
      cursor: pointer;
    }

    &.selected-item {
      background-color: #dae9f8;
      color: #1976d2;
      font-weight: 600;
    }
  }
}
</style>
